// extracted by mini-css-extract-plugin
export default {"nav":"HomeNav_nav__mU-Ys"};